// Columns that appear only when at least one loaded rate has a value for that field.
export const OPTIONAL_RATE_COLS = ["Agent Code", "Revenue Basis", "Revenue Rate"];

export function getOptionalRateColumns(rates) {
  return OPTIONAL_RATE_COLS.filter((col) =>
    rates.some((r) => r[col] != null && r[col] !== "")
  );
}
